import { UPDATE_SURVEY } from "./types";
import firebase from "../firebase";

export const updateSurvey = params => {
  
  
  if (params.type === UPDATE_SURVEY) {
    return (dispatch, getState) => {
      firebase.database.ref(`surveys/${params.companyID}/${params.surveyid}`).on("value", function(data) {
     // firebase.database.ref(`surveys/${params.companyID}/${params.thoughtID}/size`).on("value", function(data) {
      
       var myData=data.val();
        if (data.val()) {
          myData = data.val();
        } 
        else
        {
          myData = 111;
        }
        
        // if(myData===null || myData===undefined) {
        //   return (dispatch, getState) => {
        //     dispatch({
        //       type: UPDATE_SURVEY,
        //       update_Survey: 1000
        //     });
        //   };
        // } else {
         if (myData) {
          
          dispatch({
            type: UPDATE_SURVEY,
            update_Survey: myData,
          });
    
        } else {
          
          return (dispatch, getState) => {
            dispatch({
              type: UPDATE_SURVEY,
              update_Survey: 111,
            });
          };
        } 
        }
      // }
      );
   } 
 }
};
